import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
declare var angular: any;

@Component({
    selector: 'app-job-match-meetings-feedback-modal',
    templateUrl: './job-match-meetings-feedback-modal.component.html'
})
export class JobMatchMeetingsFeedbackModalComponent implements OnInit {
    jobMatchId: any;
    jobId: any;
    candidateId: any;
    feedbackType: any;
    meetingUserList: any;
    parentScheduleId: any;
    childScheduleId: any;
    callbackObject: any;
    feedbackUserIdsList: any[];
    title: string;
    workflowStep: string;
    public onClose: Subject<any>;

    constructor(
        private bsModalRef: BsModalRef,
        public bsModalService: BsModalService
    ) {
        this.onClose = new Subject();
    }

    ngOnInit(): void {
        const modalData: any = this.bsModalService.config.initialState || {};
        this.jobMatchId = modalData.jobMatchId;
        this.jobId = modalData.jobId;
        this.candidateId = modalData.candidateId;
        this.feedbackType = modalData.feedbackType;
        this.meetingUserList = modalData.meetingUserList;
        this.parentScheduleId = modalData.parentScheduleId;
        this.childScheduleId = modalData.childScheduleId;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.feedbackUserIdsList = [];
        this.title = 'Interview Feedback';
        if (this.feedbackType == 'PhoneScreen') {
            this.title = 'Phone Screen Feedback';
            this.workflowStep = 'ps';
        } else if (this.feedbackType == 'RecruiterScreening') {
            this.title = 'Recruiter Screening Feedback';
            this.workflowStep = 'rs';
        } else {
            this.workflowStep = 'in';
        }
        angular.forEach(this.meetingUserList, (val, key) => {
            this.feedbackUserIdsList.push(val.userId);
        });
    }

    closeModal(): void {
        this.onClose.next(this.callbackObject);
        this.bsModalRef.hide();
    }

    dismissModal(): void {
        this.bsModalRef.hide();
    }

    refresh(): void {
        this.callbackObject.callbackType = 'refresh';
        this.closeModal();
    }
}
